import SmazzoStesa from "./SmazzoStesa";

// Le Piacentine usano dritto + rovescio: per regola usano lo stesso caos fisico
// reale delle Vera Sibilla (stessa infrastruttura, stesso mazzo reale).
export default function Piacentine() {
  return <SmazzoStesa deck="piacentine" />;
}
